export const ALL_HOTELS_REQUEST = "ALL_HOTELS_REQUEST";
export const ALL_HOTELS_SUCCESS = "ALL_HOTELS_SUCCESS";
export const ALL_HOTELS_FAIL = "ALL_HOTELS_FAIL";

export const HOTELS_REQUEST = "HOTELS_REQUEST";
export const HOTELS_SUCCESS = "HOTELS_SUCCESS";
export const HOTELS_FAIL = "HOTELS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";